import { render, staticRenderFns } from "./FoodMajorKindStatistic.vue?vue&type=template&id=20610a36&"
import script from "./FoodMajorKindStatistic.vue?vue&type=script&lang=js&"
export * from "./FoodMajorKindStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports